<mat-card class="card-stcyle px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class="">{{ data.item.isUsuario === 'S' ? 'Editar' : 'Cadastrar' }} Funcionário</mat-card-title>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>
  <div [formGroup]="form">
  <div class="flex justify-between gap-4 items-center mt-3">
    <mat-form-field
      class="input-tg mt-message-input w-1/3"
      appearance="outline"
    >
      <mat-label>Função</mat-label>
      <input matInput formControlName="role" />
    </mat-form-field>
    <mat-form-field
      class="input-tg mt-message-input w-1/3"
      appearance="outline"
    >
      <mat-label>Nome</mat-label>
      <input matInput formControlName="name" />
    </mat-form-field>
    <mat-form-field
      class="input-tg mt-message-input w-1/3"
      appearance="outline"
    >
      <mat-label>Cpf</mat-label>
      <input matInput formControlName="cpf" />
    </mat-form-field>
  </div>
    <div class="flex justify-between gap-4 items-center mt-3">
      <mat-form-field
        class="input-tg mt-message-input w-2/4"
        appearance="outline"
      >
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" />
      </mat-form-field>
      <mat-form-field
        class="input-tg mt-message-input w-2/4"
        appearance="outline"
      >
        <mat-label>Perfil</mat-label>
        <mat-select formControlName="profile">
          @for (prof of profilesList; track prof) {
            <mat-option [value]="prof.id">{{ prof.descricao }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="flex justify-end">
    <button
      mat-flat-button
      class="btn-tg w-1/5"
      [disabled]="form.invalid || loading"
      (click)="verifyFunction()"
    >
      @if (loading) {
        <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
      } @else {
        Salvar
      }
    </button>
  </div>
</mat-card>
